import { Box, Button, Grid, Typography, useTheme } from "@mui/material"
import { i18n } from "../../translations/i18n"
import { styles } from "./style"

const NotFound = () => {
  const theme = useTheme()
  const {
    buttonStyle,
    centerStyle,
    containerStyle,
    imgStyle,
    subtitleStyle,
    titleStyle
  } = styles(theme)

  return (
    <Grid container sx={containerStyle}>
      <Box sx={centerStyle}>
        <Box
          sx={imgStyle}
          component='img'
          src='/assets/notFound.svg'
          alt='Not Found'
        />
        <Typography sx={titleStyle}>{`${i18n.t(
          "pages.notFound.title"
        )}`}</Typography>
        <Typography sx={subtitleStyle}>
          {`${i18n.t("pages.notFound.subtitle")}`}
        </Typography>
        <Button href='/' variant='contained' sx={buttonStyle}>
          {`${i18n.t("pages.notFound.btnHome")}`}
        </Button>
      </Box>
    </Grid>
  )
}

export default NotFound
